import {productConstants} from '../_constants';

export function bonusProduct(state = {}, action) {
  switch (action.type) {
    case productConstants.GET_BONUS_PRODUCTS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case productConstants.GET_BONUS_PRODUCTS_SUCCESS:
      return {
        ...state,
        ...action.data,
        loading: false,
      };
    case productConstants.GET_BONUS_PRODUCTS_ERROR:
      return {
        error: action.error,
      };

    default:
      return state;
  }
}
